export enum ECommand {
  CreateNode,
  Bold,
  Italic,
  Underline,
  Strike,
  SetParagraph,
  SetHeading,
  SetTextType,
  OrderedList,
  BulletList,
  CreateTable,
  AddRowBefore,
  AddRowAfter,
  AddColumnAfter,
  AddColumnBefore,
  DeleteTable,
  DeleteColumn,
  DeleteRow,
  Link,
  Align,
  AlignOrderedList,
  AlignBulletList,
  AlignParagraph,
  AlignHeading,
  AlignImage,
  CreateMergeTag,
  UpdateMergeTag,
  Undo,
  Redo,
  HoverDeleteColumn,
  HoverDeleteRow,
  HoverReset,
}
